import { render, staticRenderFns } from "./RbuItemModule.vue?vue&type=template&id=c1ab6548"
import script from "./RbuItemModule.vue?vue&type=script&lang=js"
export * from "./RbuItemModule.vue?vue&type=script&lang=js"
import style0 from "./RbuItemModule.vue?vue&type=style&index=0&id=c1ab6548&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports